import { render } from "../views/button.html?vue&type=template&id=7cfa90d8&ts=true&external"
import script from "../scripts/button.ts?vue&type=script&lang=ts&external"
export * from "../scripts/button.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ClientApp/components/button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7cfa90d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7cfa90d8', __exports__)) {
    api.reload('7cfa90d8', __exports__)
  }
  
  module.hot.accept("../views/button.html?vue&type=template&id=7cfa90d8&ts=true&external", () => {
    api.rerender('7cfa90d8', render)
  })

}


export default __exports__